"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowAutomationService = void 0;
class WorkflowAutomationService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Add a new workflow automation
     * @param requestBody
     * @returns WorkflowAutomationResponse
     * @throws ApiError
     */
    createWorkflowAutomation(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workflow-automation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all workflow automations
     * @param q
     * @param page
     * @param count
     * @returns WorkflowAutomationsResponse
     * @throws ApiError
     */
    getWorkflowAutomations(q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workflow-automation',
            query: {
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get workflow automation by id
     * @param id
     * @returns WorkflowAutomationResponse
     * @throws ApiError
     */
    getWorkflowAutomation(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workflow-automation/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update workflow automation
     * @param id
     * @param requestBody
     * @returns WorkflowAutomationResponse
     * @throws ApiError
     */
    updateWorkflowAutomation(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/workflow-automation/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete workflow automation
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteWorkflowAutomation(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/workflow-automation/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Duplicate workflow automation
     * @param id
     * @param requestBody
     * @returns WorkflowAutomationResponse
     * @throws ApiError
     */
    duplicateWorkflowAutomation(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workflow-automation/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get workflow automation trigger fields mapping
     * @returns FieldsMappingResponse
     * @throws ApiError
     */
    getTriggerFieldsMapping() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workflow-automation/mapping/trigger',
        });
    }
    /**
     * Get workflow automation condition fields mapping
     * @returns FieldsMappingResponse
     * @throws ApiError
     */
    getConditionFieldsMapping() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workflow-automation/mapping/condition',
        });
    }
}
exports.WorkflowAutomationService = WorkflowAutomationService;
